import { render, staticRenderFns } from "./JcTicket.vue?vue&type=template&id=2c83bdd9&scoped=true&"
import script from "./JcTicket.vue?vue&type=script&lang=js&"
export * from "./JcTicket.vue?vue&type=script&lang=js&"
import style0 from "./JcTicket.vue?vue&type=style&index=0&id=2c83bdd9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83bdd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
